<template>
  <article>
    <activity-stage>
      <template slot="instructions">
        <slot name="instructions"></slot>
      </template>
      <article class="a-sentences-wpm" slot="content">
        <assessment-helper></assessment-helper>
        <article
          class="steps-container typing-stage"
          v-if="currentRound.activitySentences"
          transition="fade"
        >
          <div
            class="step text-display-container"
            v-for="(step, index) in currentRound.activitySentences"
            :key="index"
          >
            <blinking-cursor-text :text="step" :text-step="index"></blinking-cursor-text>
          </div>
        </article>
      </article>
    </activity-stage>
    <slot name="keyboard"></slot>
  </article>
</template>

<script>
import { TweenMax } from 'gsap';

import ActivityManager from 'mixins/ActivityManager';
import AssetLoader from 'mixins/AssetLoader';
import ErrorLogger from 'mixins/ErrorLogger';
import TypingActivityHelper from 'mixins/TypingActivityHelper';

import ActivityStage from 'components/activity/ActivityStage.vue';
import AssessmentHelper from 'components/utils/AssessmentHelper.vue';
import BlinkingCursorText from 'components/text-displays/BlinkingCursorText.vue';

export default {
  components: {
    ActivityStage,
    AssessmentHelper,
    BlinkingCursorText
  },

  mixins: [ActivityManager, AssetLoader, ErrorLogger, TypingActivityHelper],

  data() {
    return {
      activityName: 'Sentences'
    };
  },
  beforeDestroy() {
    TweenMax.killAll();
  },

  methods: {
    async loadActivity() {
      this.createRounds({ stepIndicator: 'activitySentences' });
    },

    startActivity() {
      this.setupNewRound({ stepCallback: this.stepCallback });
      this.enableKeyboard();
      this.errorLoggerStart();
      this.$nextTick(() => {
        TweenMax.to('.activity-stage', 0.5, { opacity: 1 });
      });
    },

    handleCorrectKey(attempt) {
      this.sndType();
      this.incrementTypingIndex();

      this.captureKeyboardAttemptSegment(attempt, this.isEndOfCurrentSentence);

      if (this.isEndOfCurrentSentence) {
        if (this.progress.stepIndex === this.totalStepsInRound - 1) {
          this.handleRoundEnd();
          return;
        }
        this.finishStep();
      }
    },

    stepCallback() {
      return this.currentStep;
    },

    finishStep() {
      this.completeStep();
      this.setCurrentStep({ stepCallback: this.stepCallback });
    },

    handleRoundEnd() {
      if (this.isEndOfActivity) {
        this.sndBell();
        TweenMax.delayedCall(0.5, this.handleActivityEnd);
      }
    },

    handleActivityEnd() {
      this.completeActivity();
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/assets/sass/fade.scss';

.a-sentences-wpm {
  margin-top: 45px;
  position: relative;
  height: 60%;
  font-size: 1.5em;
  display: flex;
  align-items: center;
  justify-items: center;
  box-sizing: border-box;
  text-align: center;

  .typing-stage {
    margin: auto;

    &.small {
      font-size: 20px;
    }

    .text-display-container {
      margin-bottom: 10px;
    }
  }
}

.is-chrome-ipad {
  .activity-stage.a-sentences-wpm {
    margin-top: 0px;

    align-items: start;

    .typing-stage {
      margin: 45px auto 0;
    }
  }
}
</style>
